import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import { channelActions } from '../../../_actions';
import { Input } from '../../../_components';

import Akna from '../../../_assets/logo_akna.png';

import moment from 'moment';

class AknaModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      aknaLogin: '',
      aknaPassword: '',
      aknaClient: '',
      submitting: false,
      submitted: false
    }

    this.closeModal = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.activeChannels.forEach(element => {
      if (element.channel_type === 'AKNA') {
        this.setState({
          aknaLogin: '',
          aknaPassword: '',
          aknaClient: element.properties.client,
          uuid: element.uuid
        })
      }
    });
  }

  handleChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({[name]: value});
  }

  handleSubmit(e) {
    e.preventDefault();

    let self = this;

    const { aknaLogin, aknaPassword, aknaClient, uuid } = this.state;
    const { dispatch, actionType } = this.props;
    
    this.setState({submitting: true, submitted: true});
    
    if ( !aknaLogin && !aknaPassword ) 
      return this.setState({submitting: false});

    let aknaToken = btoa(`${aknaLogin}:${aknaPassword}`);
    let obj = {
      "channel": {
        "domain_uuid": JSON.parse(sessionStorage.getItem('selected_domain')).uuid,
        "channel_type": "AKNA",
        "properties": {
          "token": aknaToken,
          "client": aknaClient
        }
      }
    }

    if (actionType === 'view')
      return false

    let action
    let constant
    
    if (actionType === 'edit') {
      obj.channel['uuid'] = uuid;

      action = channelActions.update(obj);
      constant = 'UPDATE_INTEGRATION_FAILURE';
    } else {
      action = channelActions.create(obj);
      constant = 'CHANNEL_INTEGRATION_FAILURE';
    }

    dispatch(action)
      .then(data => {
        if ( data.type !== constant ) {
          this.props.evt.handleSubmit();

          self.setState({submitting: false});
  
          return toast.success(data.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            className: 'toast-success'
          });
        }
  
        self.setState({submitting: false})
  
        return toast.error(data.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-error'
        });
      });
  }

  render() {
    const { submitted, submitting, aknaLogin, aknaPassword, aknaClient } = this.state;
    const { actionType } = this.props;

    let title;
    let subtitle;
    let button;
    let buttonLoading;
    let readOnly;

    switch (actionType) {
      case 'edit':
        title = 'Editing Akna channel'
        subtitle = 'It is necessary that you provide your Akna login and password in the fields below.'
        button = 'Edit'
        buttonLoading = 'Editing...'
        break;
      case 'view':
        title = 'Akna Channel information for this Domain'
        subtitle = 'Here you can you find the configured information for this channel.'
        readOnly = true
        break;
      default:
        title = 'Adding Zenvia channel'
        subtitle = 'It is necessary that you provide your Akna login and password in the fields below.'
        button = 'Add'
        buttonLoading = 'Adding...'
        break;
    }

    return (
      <div className="modal fade" id={this.props.name+'Modal'} tabIndex="-1" role="dialog" aria-labelledby={this.props.name+'ModalLabel'} aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <img src={Akna} alt="Akna logo"/>
              <br/>
              <br/>
              <p className="title">{title}</p>
              <p className="disclaimer">{subtitle}</p>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" ref={this.closeModal}>
                <i className="lnr lnr-cross"></i>
              </button>
              <form action="#" className="form clearfix" id="aknaChannelForm" method="POST" onSubmit={this.handleSubmit}>
                <div className="content-group">
                  {
                    !readOnly ?
                      <Input
                        label="Username"
                        type="text"
                        name="aknaLogin"
                        submitted={submitted}
                        property={aknaLogin}
                        hasChanged={this.handleChange}
                        onError="Provide your Akna username"
                      />
                    : ''
                  }
                  
                  {
                    !readOnly ?
                      <Input
                        label="Password"
                        type="password"
                        name="aknaPassword"
                        submitted={submitted}
                        property={aknaPassword}
                        hasChanged={this.handleChange}
                        onError="Provide your Akna password"
                      />
                    : ''
                  }

                  <Input
                    label="Client code"
                    type="text"
                    name="aknaClient"
                    property={aknaClient}
                    hasChanged={this.handleChange}
                    onError="Provide your Akna cliente code"
                    readOnly={readOnly}
                  />
                </div>
                {
                  submitting ?
                    <button type="button" className="btn btn-blue float-right disabled" disabled>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span className="sr-only"> {buttonLoading}</span>
                    </button>    
                  : actionType === 'view' ?
                    <button type="submit" className="btn btn-blue float-right" data-dismiss="modal">OK</button> :
                    <button type="submit" className="btn btn-blue float-right">{button}</button>
                }
              </form>
              {
                actionType ?
                  <p className="edit">Last update: {moment(this.state.updated_at).format('MMMM Do YYYY, h:mm:ss a')}</p>
                : ''
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { channelStatus } = state.createChannel;
  return channelStatus;
}

const ConnectedAknaModal = connect(mapStateToProps)(AknaModal);
export { ConnectedAknaModal as AknaModal }